export const validationMessages = {
    email: "Podaj poprawny adres email",
    number: "wartość musi być liczbą",
    required: "to pole jest wymagane",
    phone: "nieprawidłowy numer telefonu",
    maxLength: "maksymalna długość to 500 znaków"
} as const;
export const validationMessages = {
    email: "Podaj poprawny adres email",
    number: "wartość musi być liczbą",
    required: "to pole jest wymagane",
    phone: "nieprawidłowy numer telefonu",
    maxLength: "maksymalna długość to 500 znaków"
} as const;
